//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchFlowDetail } from '@/api/MLXC/countryGovern/suggestManage';
export default {
  props: ['keyValue', 'flowNum', 'showDialog'],
  data: function data() {
    return {
      listLoading: false,
      areaId: '',
      innerVisible: true,
      dialogImageUrl: '',
      dialogVisible: false,
      dataList: [],
      fileList: [],
      childData: {},
      pictureList: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    trimStr: function trimStr(str, length) {
      if (str === null || str === '' || str === undefined) {
        return '';
      } else {
        if (str.length > length) {
          return str.substring(0, length) + '...';
        } else {
          return str;
        }
      }
    },
    tooltipDisabled: function tooltipDisabled(str, length) {
      if (str !== null) {
        if (str.length > length) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    // 隐藏大部分字符串
    splideStr: function splideStr(str, length) {
      if (str !== null && str !== undefined) {
        if (str.length >= length) {
          return str.substring(0, length - 1) + '...';
        } else {
          return str;
        }
      }
    },
    init: function init() {
      var _this = this;

      this.fileList = [];

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        fetchFlowDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.dataList = response.data.data.complaintReturnInfoVos;
        });
      } else {
        this.areaId = '';
        this.childData = {};
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairDetail');
    }
  }
};